import { css } from "@emotion/css";
import { BorderRadius, Colors, Spacing } from "@snapchat/snap-design-system";

export const lensSpaceLensesForUpdatePageContent = css`
    width: 898px;
`;

export const lensSpaceSelectionContainer = css`
    width: 100%;
    margin-top: ${Spacing.LG}px;
    padding: ${Spacing.LG}px;

    background-color: ${Colors.WHITE};
    border-radius: ${BorderRadius.container}px ${BorderRadius.container}px 0 0;
`;

export const lensSpaceLensList = css`
    .sds-card {
        margin: 0;
    }
`;
